const RAIL_VARIANTS = {
  home: {
    toggle: 'hidden lg:inline-flex',
    strip: 'hidden lg:flex',
    foldedContent: 'lg:hidden',
  },
  vela: {
    toggle: 'hidden vela:inline-flex',
    strip: 'hidden vela:flex',
    foldedContent: 'vela:hidden',
  },
} as const;

type RailVariant = keyof typeof RAIL_VARIANTS;

const RAIL_GRID_TRANSITION =
  'transition-[grid-template-columns] duration-300 ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none';

const RAIL_CONTENT_REVEAL =
  'animate-in fade-in-0 duration-200 delay-300 fill-mode-both motion-reduce:animate-none';

const VELA_RAIL_CONTENT_REVEAL =
  'animate-in fade-in-0 duration-[220ms] delay-[160ms] fill-mode-both motion-reduce:animate-none';

const RAIL_STRIP_REVEAL =
  'animate-in fade-in-0 slide-in-from-right-2 duration-300 motion-reduce:animate-none';

const HOME_RAIL_GRID = {
  open: 'lg:grid-cols-[minmax(0,1fr)_var(--assistant-rail-width)]',
  collapsed: 'lg:grid-cols-[minmax(0,1fr)_var(--rail-collapsed-width)]',
} as const;

const VELA_RAIL_GRID = {
  open: 'vela:grid-cols-[266px_minmax(0,1fr)_var(--assistant-rail-width)]',
  collapsed: 'vela:grid-cols-[266px_minmax(0,1fr)_var(--rail-collapsed-width)]',
} as const;

export {
  RAIL_VARIANTS,
  HOME_RAIL_GRID,
  VELA_RAIL_GRID,
  RAIL_GRID_TRANSITION,
  RAIL_CONTENT_REVEAL,
  VELA_RAIL_CONTENT_REVEAL,
  RAIL_STRIP_REVEAL,
};
export type {RailVariant};
